import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import LatestSection from "./components/LatestSection";
import HotSection from "./components/HotSection";
import SpecialSection from "./components/SpecialSection";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <>
      <title>善良的嫂子-热门影视剧介绍与精彩剧情解析</title>
      <meta
        name="description"
        content="善良的嫂子网站提供热门影视剧《善良的嫂子》的剧情介绍、演员信息及相关影视资源推荐，满足用户对该剧的全面了解需求。"
      />
      <meta
        name="keywords"
        content="善良的嫂子,影视剧,剧情介绍,演员名单,影视资源,电视剧推荐,影视解析"
      />

      <HeroCarousel />
      <CategoryEntries />
      <LatestSection />
      <HotSection />
      <SpecialSection />
      <SiteIntro />
    </>
  );
}